import React from 'react';

export const SourceTypeDouble = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_double"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="bck-SorceDataType"
        fill="#575757"
        x="0"
        y="0"
        width="32"
        height="32"
        rx="2"
      ></rect>
      <g
        id="DBL"
        transform="translate(3.500000, 8.000000)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <path
          d="M0,15.3979239 L0,0 L3.26557093,0 C4.53431373,0 5.49668397,0.346020761 6.15268166,1.03806228 C6.80867935,1.73010381 7.1366782,2.71049596 7.1366782,3.97923875 L7.1366782,11.1807958 C7.1366782,12.622549 6.78705306,13.685842 6.08780277,14.3706747 C5.38855248,15.0555075 4.38292964,15.3979239 3.07093426,15.3979239 L0,15.3979239 Z M2.20588235,2.07612457 L2.20588235,13.3217993 L3.22231834,13.3217993 C3.8422722,13.3217993 4.28200692,13.1668108 4.54152249,12.8568339 C4.80103806,12.546857 4.93079585,12.0602653 4.93079585,11.3970588 L4.93079585,3.97923875 C4.93079585,3.37370242 4.80824683,2.90513264 4.56314879,2.57352941 C4.31805075,2.24192618 3.87110727,2.07612457 3.22231834,2.07612457 L2.20588235,2.07612457 Z"
          id="Shape"
        ></path>
        <path
          d="M9.21280277,15.3979239 L9.21280277,0 L12.4351211,0 C13.1415802,0 13.7435121,0.108131488 14.240917,0.324394464 C14.7383218,0.540657439 15.1456171,0.829008074 15.4628028,1.18944637 C15.7799885,1.54988466 16.0070646,1.9643887 16.1440311,2.43295848 C16.2809977,2.90152826 16.349481,3.38811995 16.349481,3.89273356 L16.349481,4.4550173 C16.349481,4.87312572 16.3170415,5.22635525 16.2521626,5.51470588 C16.1872837,5.80305652 16.0899654,6.05536332 15.9602076,6.2716263 C15.7151096,6.67531719 15.3402537,7.02133795 14.8356401,7.30968858 C15.3546713,7.55478662 15.7367359,7.91522491 15.9818339,8.39100346 C16.2269319,8.86678201 16.349481,9.51557093 16.349481,10.3373702 L16.349481,11.2024221 C16.349481,12.5576701 16.0214821,13.5957324 15.3654844,14.316609 C14.7094867,15.0374856 13.6606113,15.3979239 12.2188581,15.3979239 L9.21280277,15.3979239 Z M11.4186851,8.26124567 L11.4186851,13.1920415 L12.3702422,13.1920415 C12.8171857,13.1920415 13.1668108,13.1271626 13.4191176,12.9974048 C13.6714245,12.8676471 13.8624567,12.6874279 13.9922145,12.4567474 C14.1219723,12.2260669 14.2012687,11.9521338 14.2301038,11.6349481 C14.2589389,11.3177624 14.2733564,10.9717416 14.2733564,10.5968858 C14.2733564,10.2076125 14.2517301,9.86880046 14.2084775,9.58044983 C14.1652249,9.29209919 14.0787197,9.04700115 13.9489619,8.84515571 C13.8047866,8.64331027 13.6101499,8.49553057 13.3650519,8.40181661 C13.1199539,8.30810265 12.7955594,8.26124567 12.3918685,8.26124567 L11.4186851,8.26124567 Z M11.4186851,2.07612457 L11.4186851,6.31487889 L12.4134948,6.31487889 C13.1487889,6.31487889 13.6425894,6.13105536 13.8948962,5.7634083 C14.147203,5.39576125 14.2733564,4.85870819 14.2733564,4.15224913 C14.2733564,3.46020761 14.1327855,2.94117647 13.8516436,2.59515571 C13.5705017,2.24913495 13.0622837,2.07612457 12.3269896,2.07612457 L11.4186851,2.07612457 Z"
          id="Shape"
        ></path>
        <polygon
          id="Path"
          points="18.4256055 15.3979239 18.4256055 0 20.6314879 0 20.6314879 13.1920415 25 13.1920415 25 15.3979239"
        ></polygon>
      </g>
    </g>
  </svg>
);
